
module.exports = {
  footerText: 'Copyright Uniserved © ',
}
